/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EditionEnum } from './editionEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface CommerceSpecTenant { 
    edition?: EditionEnum;
    mode?: CommerceModeEnum;
    /**
     * Unique identifier of deployment
     */
    deployment_id: string;
}
export namespace CommerceSpecTenant {
}


